export default __webpack_public_path__ + "static/media/image-ph-study-ranking-n-w.b5315146.png";